import { InjectionToken } from '@angular/core';

export interface IAccessTokenSource {
    getAccessToken(): string;
}

export class NullAccessTokenSource implements IAccessTokenSource {
    public getAccessToken(): string {
        return null;
    }
}

export let accessTokenSourceToken = new InjectionToken<IAccessTokenSource>(
    'AccessTokenSource',
    {
        factory: () => new NullAccessTokenSource(),
        providedIn: 'root'
    });
